export default __webpack_public_path__ + "static/media/benefitsIcon2.4d938085.webp";